import './Theme.Page.Lightbox.scss';
export default 'ThemePageLightbox';
